<div class="row text-center ms-4 mt-5" *ngIf="header">
  <div class="col-2 me-2">
    <h6 class="h6-custom" i18n="Si header filtri|pagina risultati">Si</h6>
  </div>
  <div class="col-2">
    <h6 class="h6-custom" i18n="No header filtri|pagina risultati">No</h6>
  </div>
</div>

<div class="d-flex justify-content-center align-items-center flex-row my-2" href="#">
  <div class="col-2 mt-2">
    <div class="form-check">
      <input id="checkbox{{filterModel.id}}true" type="checkbox" [disabled]="disabled"
        i18n-aria-label="Definizione a si di un filtro|Sezione di un filtro"
        (change)="triggerSearch('si')" [(ngModel)]="filterModel.si">
      <label for="checkbox{{filterModel.id}}true"><span class="sr-only p-0">{{filterModel.label}} si</span></label>
    </div>
  </div>
  <div class="col-2 mt-2">
    <div class="form-check">
      <input id="checkbox{{filterModel.id}}false" type="checkbox" [disabled]="disabled"
        i18n-aria-label="Definizione a no di un filtro|Sezione di un filtro"
        (change)="triggerSearch('no')" [(ngModel)]="filterModel.no">
      <label for="checkbox{{filterModel.id}}false" ><span class="sr-only">{{filterModel.label}} no</span></label>
    </div>
  </div>

  <div class="d-flex align-items-center col-6 ms-2">
    <ng-content></ng-content>
  </div>
</div>